<div class="timeline-chart">
    <div id="activity-timeline-chart"></div>
</div>